import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Newspaper, ArrowRight, Calendar } from "lucide-react";
import api from "@/lib/api";
import { useTranslation } from "react-i18next";
import { applySeo } from "@/lib/seo";

const LANGS = [{ v: "", l: "Toate" }, { v: "ro", l: "RO" }, { v: "hu", l: "HU" }, { v: "en", l: "EN" }];
const fmtDate = (d) => { try { return new Date(d).toLocaleDateString("ro-RO", { year: "numeric", month: "short", day: "numeric" }); } catch { return ""; } };

export default function News() {
  const { i18n } = useTranslation();
  const [posts, setPosts] = useState([]);
  const [lang, setLang] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    return applySeo({
      title: "Știri & Analize din industria lemnului | OXO.ro",
      description: "Analize de piață, prețuri utilaje și sfaturi de la experți OXO — știri actuale din industria prelucrării lemnului.",
      type: "website",
    });
  }, []);

  useEffect(() => {
    setLoading(true);
    api.get("/news", { params: lang ? { language: lang } : {} })
      .then((r) => setPosts(r.data.posts)).catch(() => {}).finally(() => setLoading(false));
  }, [lang]);

  return (
    <div className="max-w-5xl mx-auto px-6 py-12" data-testid="news-page">
      <div className="mb-8">
        <div className="flex items-center gap-2 text-[11px] uppercase tracking-[0.25em] font-bold text-orange-600 mb-2">
          <Newspaper className="w-3.5 h-3.5" /> Știri · Hírek · News
        </div>
        <h1 className="text-3xl sm:text-4xl font-black tracking-tight">Analize din industria lemnului</h1>
        <p className="text-slate-500 mt-2 max-w-2xl">Piața utilajelor, prețuri, uscare și sfaturi de la experți — actualizate constant.</p>
      </div>

      <div className="flex gap-2 mb-8">
        {LANGS.map((l) => (
          <button key={l.v} onClick={() => setLang(l.v)}
            className={`px-3 py-1.5 text-xs font-bold uppercase tracking-wide border transition-colors ${lang === l.v ? "bg-slate-900 text-white border-slate-900" : "border-slate-300 text-slate-500 hover:border-slate-900"}`}
            data-testid={`news-lang-${l.v || "all"}`}>{l.l}</button>
        ))}
      </div>

      <div className="text-sm text-slate-500 mb-4" data-testid="news-count">{loading ? "Se încarcă..." : `${posts.length} articole`}</div>

      <div className="space-y-4">
        {loading ? (
          Array.from({ length: 4 }).map((_, i) => <div key={i} className="border border-slate-200 h-28 animate-pulse bg-slate-100" />)
        ) : posts.length === 0 ? (
          <div className="border border-slate-200 p-12 text-center text-slate-400" data-testid="no-news">Niciun articol încă.</div>
        ) : (
          posts.map((p) => (
            <Link key={p.id} to={`/news/${p.slug}`} className="group flex flex-col sm:flex-row gap-4 border border-slate-200 hover:border-orange-400 p-5 transition-colors" data-testid={`news-card-${p.slug}`}>
              <div className="flex-1">
                <div className="flex items-center gap-3 mb-2">
                  <span className="text-[10px] uppercase font-bold tracking-wider bg-slate-100 px-2 py-0.5">{p.language}</span>
                  <span className="flex items-center gap-1 text-xs text-slate-400"><Calendar className="w-3 h-3" /> {fmtDate(p.created_at)}</span>
                </div>
                <h2 className="font-bold text-lg leading-snug group-hover:text-orange-600 transition-colors">{p.title}</h2>
                <p className="text-sm text-slate-500 mt-2 line-clamp-2">{p.excerpt}</p>
              </div>
              <ArrowRight className="w-5 h-5 text-slate-300 group-hover:text-orange-600 self-center shrink-0 hidden sm:block" />
            </Link>
          ))
        )}
      </div>
    </div>
  );
}
